import React, { PureComponent } from 'react';

import { message as AntMessage } from 'antd';
import { services } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { errorHandle } from '../../services';

const api = services.api;
/**
 * 可视化页面预览
 */
export class CategoryRefreshButton extends PureComponent<any, any> {
    refeshCategeroy = (id: number, entity: Entity) => {
        api.post(
            { display_category_id: id },
            { apiPath: '/display_category/:display_category_id' }
        ).then(() => {
            AntMessage.success('刷新成功');

            // 列表数据刷新
            entity.search({
                ...entity.params,
                ...entity.filters,
            });
        })
        .catch(errorHandle);
    };
    render() {
        const { row: { refresh, id }, entity } = this.props;
        if (refresh !== 'true') return '';
        return (
            <a className="table-action-column-item" onClick={this.refeshCategeroy.bind(this, id, entity)}>
                刷新
            </a>
        );
    }
}
